export const DEFAULT_STATE = {
  draw: null,
  type: null,
  upload: null,
};

const imageUrls = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'GET_SIGNATURES_SUCCESS': {
      const {
        drawn: draw,
        typed: type,
        uploaded: upload,
      } = action.res.signatures;
      if (action.isSingleSignatureMode && type) {
        // This mode is set in static builder signatures.
        // There is currently no capability to set upload signatures in static builder
        // so we do not check them here. This is only for the case where we have both
        // draw and type signatures and here we prioritize type signatures.
        return { draw: null, type, upload };
      }
      return { draw, type, upload };
    }
    case 'SAVE_SINGLE_SIGNATURE':
      return {
        ...DEFAULT_STATE,
        [action.sigType]: action.imgUrl,
      };
    case 'SAVE_SIGNATURE_SUCCESS':
      return {
        ...state,
        [action.sigType]: action.imgUrl,
      };
    case 'REMOVE_SIGNATURE_SUCCESS':
      return {
        ...state,
        [action.sigType]: null,
      };
    default:
      return state;
  }
};

export default imageUrls;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureReducer/imageUrls.jsx